// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh2[data-v-352cc348] { font-size: 18px; color: var(--main-blue-3); text-align: center; max-width: 400px; margin: 0px auto; margin-bottom: 10px;\n}\n.peppol-info[data-v-352cc348] { font-size: 14px; color: var(--main-gray-5); text-align: center; max-width: 450px; margin: 0px auto; margin-bottom: 20px; line-height: 22px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
